"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiForm, { UiFormAnnotations, UiFormController } from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import VerifyInput, { VerifyInputController } from "@/components/VerifyInput.vue";
import PasswordInput from "@/views/accountItems/components/PasswordInput.vue";
import i18n from "@/lang";
export class AccountChildEditBindForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.phone = "";
    this.verifyCode = "";
    this.account = "";
    this.password = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([{
    required: true,
    message: i18n.t("accountchildeditbinddialog.mobile_phone_number_cannot_be_empty"),
    trigger: "blur"
  }])
], AccountChildEditBindForm.prototype, "phone", 2);
__decorateClass([
  UiFormAnnotations.Rule([{
    required: true,
    message: i18n.t("accountchildeditbinddialog.verification_code_cannot_be_empty"),
    trigger: "blur"
  }])
], AccountChildEditBindForm.prototype, "verifyCode", 2);
let AccountChildEditBindDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.row = {};
    this.mode = "bind";
    this.title = this.$t("accountchildeditbinddialog.binding_mobile_phone");
    this.dialogLoading = false;
    this.dialog = new UiDialogController();
    this.controller = new AccountChildEditBindForm();
    this.verifyInput = new VerifyInputController("api://base.auth/api/v1/verify_code/send", 11);
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  submit() {
    return __async(this, null, function* () {
      try {
        if (this.mode === "unbind") {
          const response = yield API.put(`api://base.auth/api/v1/user/unbindphone`, {
            code: this.controller.verifyCode,
            phone: this.controller.phone
          });
          this.$message.success(this.$t("accountchildeditbinddialog.untied_successfully"));
        }
        if (this.mode === "bind") {
          yield API.post(`api://base.auth/api/v1/user/bindphone`, {
            code: this.controller.verifyCode,
            phone: this.controller.phone,
            password: this.controller.password
          });
          this.$message.success(this.$t("accountchildeditbinddialog.binding_successful"));
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.close();
      }
    });
  }
  open(phone, mode = "bind") {
    this.mode = mode;
    if (this.mode === "bind") {
      this.title = this.$t("accountchildeditbinddialog.binding_mobile_phone");
      this.verifyInput.query.code = 11;
    }
    if (this.mode === "unbind") {
      this.title = this.$t("accountchildeditbinddialog.unbind");
      this.verifyInput.query.code = 11;
    }
    this.controller = new AccountChildEditBindForm();
    this.controller.phone = phone;
    this.dialog.visible = true;
  }
  close() {
    this.dialog.visible = false;
    this.$emit("refresh");
  }
};
AccountChildEditBindDialog = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit,
      UiDialog,
      VerifyInput,
      PasswordInput
    }
  })
], AccountChildEditBindDialog);
export {
  AccountChildEditBindDialog as default
};
